import React, { useState } from 'react'
import {
  Table,
  Tr,
  Th,
  Animation,
  PageWrapper,
  H1WithBack,
  PageFooter,
  Separator,
  Flex,
  Button,
} from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import {
  getParams,
  handlePagination,
} from 'utils/helpers'
import { NavBar } from 'components/NavBar/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import { clearWorkScheduleModels, deleteWorkScheduleModel, getWorkScheduleModels } from 'features/shifts/shiftsSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import useQueryPagination from 'hooks/useQueryPagination'
import { IGetWorkScheduleModel } from 'types/api/shiftsApi.interface'
import { Options } from 'components/Options/Options'
import { WorkScheduleModelModal } from './WorkScheduleModelModal'
import { ModalTypes } from 'types/global.interface'

export const WorkScheduleModels = () => {
  const { workScheduleModels } = useSelector((store: RootState) => store.shifts)
  const dispatch = useDispatch<AppDispatch>()
  const [params, setParams] = useState<any>(getParams({ location, limit: 5 }))
  const [modal, setModal] = useState({ open: false, value: null })


  useQueryPagination({ fetchFunctions: [getWorkScheduleModels], cleanUpFunctions: [clearWorkScheduleModels], params })


  const removeModel = (id: number): void => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteWorkScheduleModel(id))
        },
        word: 'delete model',
        setParams: { type: ModalTypes.Delete, f: setParams, noItems: workScheduleModels.data.length == 1 }
      }),
    )
  }


  return (
    <>
      <NavBar />
      <PageWrapper>
        <Animation>
          <Flex between center>
            <H1WithBack arrow title='Work Schedule Models' />
            <Button orange onClick={() => setModal({ open: true, value: null })}>
              Add Model
            </Button>
          </Flex>
          {!workScheduleModels.data.length ? (
            <NoItems title='Models' />
          ) : (
            <Table>
              <Th next >
                <Td w='25%' noTooltip text='Model Name' />
                <Td w='15%' noTooltip text='Work days' />
                <Td w='55%' noTooltip text='Rest days' />
                <Td w='5%'></Td>
              </Th>
              {
                workScheduleModels.data.map((item: IGetWorkScheduleModel) => {
                  return (
                    <Tr key={item.id}>
                      <Td w='25%' text={item.name} />
                      <Td w='15%' noTooltip text={item.workDaysCount} />
                      <Td w='55%' noTooltip text={item.restDaysCount} />
                      <Td noTooltip w='5%'>
                        <Options item={item} title='Work Schedule Model' handleRemove={removeModel} openModal={() => setModal({ open: true, value: item })} />
                      </Td>
                    </Tr>
                  )
                })}
            </Table>
          )}

        </Animation>
        {modal.open && <WorkScheduleModelModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
      </PageWrapper>
      <PageFooter>
        {workScheduleModels.totalPages > 1 && (
          <Pagination
            setPage={(page) => handlePagination(page, setParams, 5)}
            pageCount={Math.ceil(workScheduleModels.totalPages)}
            forcePage={(params.page ? params.page : 1) - 1}
          />
        )}
      </PageFooter>

    </>
  )
}
